import React from 'react';
import logoTransparente from '../../assets/logo-posgo.png';

const BrandLogo = ({ delay = 0, topPosition = '20px' }) => {
  return (
    <>
      <style>{`
        @keyframes brandSlideIn {
          from {
            opacity: 0;
            transform: translateX(50px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }
        
        .brand-logo-container {
          animation: brandSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
          animation-delay: ${delay}s;
          animation-fill-mode: both;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .brand-logo-container:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 20px rgba(0,0,0,0.25);
        }
        
        .brand-logo-container:hover img {
          transform: rotate(5deg);
        }
        
        .brand-logo-container img {
          transition: transform 0.3s ease;
        }
      `}</style>

      <div
        className="brand-logo-container"
        style={{
          position: 'fixed',
          top: topPosition,
          right: '20px',
          zIndex: 9999,
          background: 'white',
          padding: '10px 18px',
          borderRadius: '14px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: '14px'
        }}>
        <img
          src={logoTransparente}
          alt="PosGo"
          style={{
            height: '55px',
            width: 'auto',
            display: 'block'
          }}
        />
        <span style={{
          fontSize: '1.8rem',
          fontWeight: '700',
          color: '#db2113',
          fontFamily: 'Quicksand, sans-serif',
          lineHeight: 1
        }}>
          PosGo.cl
        </span>
      </div>
    </>
  );
};

export default BrandLogo;